import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import Pagination from "./Pagination";
// import ArrowBack from "@material-ui/icons/ArrowBack"
// import ArrowForward from "@material-ui/icons/ArrowForward"

export const destroyDataTable = (tableId) => {
    if (($).fn.dataTable.isDataTable('#' + tableId)) {
        var table = $('#' + tableId).DataTable();
        table.destroy();
    }
}

export const applyDataTableNoPagingFilter = (tableId) => {
    try {
        let oTable;
        oTable = $('#' + tableId).DataTable({
            destroy: true,
            "responsive": true,
            "autoWidth": true,
            "bInfo": false,
            "info": false,
            "lengthChange": false,
            "bFilter": false,
            "bPaginate": false,
            "pagingType": "simple_numbers",
            "language": {
                paginate: {
                    "next": '<i class="fa fa-angle-right" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                }
            },
        });
    } catch (error) { 
        return error;
    }
}

export const applyDataTable = (tableId, rows = [], columns = [], searchElemId = "", pageLenSelectElem = "", searchBtnElemId = "", dateformat,order) => {
    try {
        let oTable;
        if (columns.length > 0) {
            oTable = $('#' + tableId).DataTable({
                "bDestroy": true,
                "columnDefs": columns,
                "order": [order],
                "dom": "Rlfrtip",
                'colReorder': { 'allowReorder': false },
                "responsive": true,
                "autoWidth": false,
                "bInfo": false,
                "info": false,
                "lengthChange": false,
                "bFilter": false,
                "oLanguage": {
                    "sLengthMenu": "_MENU_ Per page",
                },
                "paging": false,
                "language": {
                    paginate: {
                        // "next": '<span><i class="fa fa-angle-double-right"></i></span>',
                        // "previous": '<span><i class="fa fa-angle-double-left"></i></span>',
                        // "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        // "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    }
                },
                searching: searchElemId != "" ? true : false,
                // data: rows,
                // columns: columns
            });
            $.fn.dataTableExt.oSort['day-asc'] = function (a, b) {
                if (dateformat == "MM/DD/YYYY") {
                    var xdate = a.split('/');
                    a = xdate[1] + "/" + xdate[0] + "/" + xdate[2];
                    var ydate = b.split('/');
                    b = ydate[1] + "/" + ydate[0] + "/" + ydate[2];
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newA) - +new Date(newB)
                }
                else {
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newA) - +new Date(newB)
                }
            };

            $.fn.dataTableExt.oSort['day-desc'] = function (a, b) {
                if (dateformat == "MM/DD/YYYY") {
                    var xdate = a.split('/');
                    a = xdate[1] + "/" + xdate[0] + "/" + xdate[2];
                    var ydate = b.split('/');
                    b = ydate[1] + "/" + ydate[0] + "/" + ydate[2];
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newB) - +new Date(newA)
                }
                else {
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newB) - +new Date(newA)
                }
            };
        } else if (rows.length > 0) {
            oTable = $('#' + tableId).DataTable({
                "bDestroy": true,
                "responsive": true,
                "columnDefs": columns,
                "order": [order],
                "dom": "Rlfrtip",
                'colReorder': { 'allowReorder': false },
                "autoWidth": false,
                "bInfo": false,
                "info": false,
                "lengthChange": false,
                "bFilter": false,
                "oLanguage": {
                    "sLengthMenu": "_MENU_ Per page",
                },
                //"scrollX": true,

                "paging": false,
                "language": {
                    paginate: {
                        "next": '<span><i class="fa fa-angle-double-right"></i></span>',
                        "previous": '<span><i class="fa fa-angle-double-left"></i></span>',
                        "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    }
                },
                searching: searchElemId != "" ? true : false,
                data: rows
            });
        } else {
            oTable = $('#' + tableId).DataTable({
                "bDestroy": true,
                "responsive": true,
                "autoWidth": false,
                "bInfo": false,
                "info": false,
                "dom": "Rlfrtip",
                // "columnDefs": [
                //     { "orderable": false, "targets": [0] },
                // ],
                 "order": [order],
                // "order": [[1, 'asc']],
                'colReorder': { 'allowReorder': false },
                "lengthChange": false,
                "pagingType": "simple_numbers",
                "oLanguage": {
                    "sLengthMenu": "_MENU_ Per page",
                },
                //"scrollX": true,
                //"bLengthChange": false,
                //"bFilter": false,
                "paging": false,

                "language": {
                    paginate: {
                        "next": '<span><i class="fa fa-arrow-right"></i></span>',
                        "previous": '<span><i class="fa fa-arrow-left cursorPointer"></i> </span>',
                        "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    }
                },
                searching: searchElemId != "" ? true : false,
            });
        }
        if (searchElemId != "") {
            $("#" + tableId + "_wrapper .dataTables_filter").hide();
            //pay attention to capital D, which is mandatory to retrieve "api" datatables' object, as @Lionel said
            if (searchBtnElemId == "") {
                $('#' + searchElemId).keyup(function (event) {
                    if (event.which == 13) {
                        event.preventDefault();
                    } else {
                        oTable.search($(this).val()).draw();
                    }
                });
            } else {
                $('#' + searchBtnElemId).on('click', function () {
                    var val = $('#' + searchElemId).val();
                    oTable.search(val).draw();
                });
            }
        }

        if (pageLenSelectElem != "") {
            $("#" + tableId + "_wrapper .dataTables_length").hide();
            $('#' + pageLenSelectElem).on('change', function () {
                var len = $(this).val();
                oTable.page.len(len).draw();
            });
        }

    } catch (error) {
        return error;
    }
}
export const applyDataTable1 = (tableId, rows = [], columns = [], searchElemId = "", pageLenSelectElem = "", searchBtnElemId = "", dateformat,order) => {
    try {
        let oTable;
        if (columns.length > 0) {
            oTable = $('#' + tableId).DataTable({
                "bDestroy": true,
                "columnDefs": columns,
                "order": [order],
                "dom": "Rlfrtip",
                'colReorder': { 'allowReorder': false },
                "responsive": true,
                "autoWidth": false,
                "bInfo": false,
                "info": false,
                "lengthChange": false,
                "bFilter": false,
                "oLanguage": {
                    "sLengthMenu": "_MENU_ Per page",
                },
                "paging": false,
                "language": {
                    paginate: {
                        // "next": '<span><i class="fa fa-angle-double-right"></i></span>',
                        // "previous": '<span><i class="fa fa-angle-double-left"></i></span>',
                        // "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        // "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    }
                },
                searching: searchElemId != "" ? true : false,
                // data: rows,
                // columns: columns
            });
            $.fn.dataTableExt.oSort['day-asc'] = function (a, b) {
                if (dateformat == "MM/DD/YYYY") {
                    var xdate = a.split('/');
                    a = xdate[1] + "/" + xdate[0] + "/" + xdate[2];
                    var ydate = b.split('/');
                    b = ydate[1] + "/" + ydate[0] + "/" + ydate[2];
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newA) - +new Date(newB)
                }
                else {
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newA) - +new Date(newB)
                }
            };

            $.fn.dataTableExt.oSort['day-desc'] = function (a, b) {
                if (dateformat == "MM/DD/YYYY") {
                    var xdate = a.split('/');
                    a = xdate[1] + "/" + xdate[0] + "/" + xdate[2];
                    var ydate = b.split('/');
                    b = ydate[1] + "/" + ydate[0] + "/" + ydate[2];
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newB) - +new Date(newA)
                }
                else {
                    const newA = a.split('/').reverse().join('-');
                    const newB = b.split('/').reverse().join('-');
                    return +new Date(newB) - +new Date(newA)
                }
            };
        } else if (rows.length > 0) {
            oTable = $('#' + tableId).DataTable({
                "bDestroy": true,
                "responsive": true,
                "columnDefs": columns,
                "order": [order],
                "dom": "Rlfrtip",
                'colReorder': { 'allowReorder': false },
                "autoWidth": false,
                "bInfo": false,
                "info": false,
                "lengthChange": false,
                "bFilter": false,
                "oLanguage": {
                    "sLengthMenu": "_MENU_ Per page",
                },
                //"scrollX": true,

                "paging": false,
                "language": {
                    paginate: {
                        "next": '<span><i class="fa fa-angle-double-right"></i></span>',
                        "previous": '<span><i class="fa fa-angle-double-left"></i></span>',
                        "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    }
                },
                searching: searchElemId != "" ? true : false,
                data: rows
            });
        } else {
            oTable = $('#' + tableId).DataTable({
                "bDestroy": true,
                "responsive": true,
                "autoWidth": false,
                "bInfo": false,
                "info": false,
                "dom": "Rlfrtip",
                // "columnDefs": [
                //     { "orderable": false, "targets": [0] },
                // ],
                "order": [order],
                // "order": [[2, 'asc']],
                'colReorder': { 'allowReorder': false },
                "lengthChange": false,
                "pagingType": "simple_numbers",
                "oLanguage": {
                    "sLengthMenu": "_MENU_ Per page",
                },
                //"scrollX": true,
                //"bLengthChange": false,
                //"bFilter": false,
                "paging": false,

                "language": {
                    paginate: {
                        "next": '<span><i class="fa fa-arrow-right"></i></span>',
                        "previous": '<span><i class="fa fa-arrow-left cursorPointer"></i> </span>',
                        "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    }
                },
                searching: searchElemId != "" ? true : false,
            });
        }
        if (searchElemId != "") {
            $("#" + tableId + "_wrapper .dataTables_filter").hide();
            //pay attention to capital D, which is mandatory to retrieve "api" datatables' object, as @Lionel said
            if (searchBtnElemId == "") {
                $('#' + searchElemId).keyup(function (event) {
                    if (event.which == 13) {
                        event.preventDefault();
                    } else {
                        oTable.search($(this).val()).draw();
                    }
                });
            } else {
                $('#' + searchBtnElemId).on('click', function () {
                    var val = $('#' + searchElemId).val();
                    oTable.search(val).draw();
                });
            }
        }

        if (pageLenSelectElem != "") {
            $("#" + tableId + "_wrapper .dataTables_length").hide();
            $('#' + pageLenSelectElem).on('change', function () {
                var len = $(this).val();
                oTable.page.len(len).draw();
            });
        }

    } catch (error) {
        return error;
    }
}


